// extracted by mini-css-extract-plugin
module.exports = {"link":"index_link__2rsib","primary":"index_primary__ov4W9","danger":"index_danger__227gX","nunito":"index_nunito__mJ4YQ","montserrat":"index_montserrat__25Sih"};